import React, { useState, useEffect, useContext } from 'react';
import { url, history, latinAlphabet } from '../../utils/variables';
import { getDirection, pexios, toast } from '../../utils/functions';
import { useSelector } from 'react-redux';
import Maps from '../../components/master/Maps';
import defaultProfile from '../../assets/images/user-icon2.png';
import { useTranslation } from 'react-i18next';
import { TitleContext } from '../../App';

export default function ExpertMap() {
    const { t, i18n } = useTranslation();
    const user = useSelector((store) => store.user);
    const { id, type } = useSelector((store) => store.routerData);

    const [data, setData] = useState({});
    const [loader, setLoader] = useState(false);

    const profilePic = data?.user?.avatar?.uid || null;
    const culprit = data?.user || {};
    const losses = data?.losses || [];

    const [descriptions, setDescriptions] = useState(data?.description || []);
    const [ newDescription , setNewDescription] = useState('')
    const [descriptionLoading , setDescriptionLoading] = useState(false)
    // const {setTitle} = useContext(TitleContext)
    // useEffect(()=>{
    //     setTitle('')
    // },[])

    useEffect(() => {
        switch (type) {
            case 'accident':
                pexios('/api/v2/get_accident', 'post', { accident_id: id, type: 'accident' })
                    .then(res => {
                        setData(res.data.data);
                        setDescriptions(res.data.data.description);
                    });
                break;
            case 'register':
                pexios('/api/get_register_expert_map', 'post', { id })
                    .then(res => {
                        setData(res.data.data);
                        setDescriptions(res.data.data.description);
                    });
                break;
            default: break;
        }
    }, [id, type]);
   
    const arrived = () => {
        setLoader(true);
        switch (type) {
            case 'accident':
                pexios('api/expert_arrived', 'post', { accident_id: id })
                    .then(() => {
                        history.push('/culprit-detail');
                    });
                break;
            case 'register':
                history.push('/register-images');
                break;
            default: break;
        }
    }
///
    function submitNewDescription (){
        if(!newDescription.trim()) {
            toast('لطفا متن توضیح را وارد نمایید.','error');
            return;
        }
        setDescriptionLoading(true)
        pexios('api/v2/add-new-description', 'post', {
            id: id, 
            description: newDescription,
            type : type
        })
           .then(res=>{
            setDescriptions(prevState => ([
                ...prevState,
                res.data.data
            ]));
            setDescriptionLoading(false)
            setNewDescription('');
           })
    }
    function onlineExamine() {
        pexios(`api/create_online_report/${id}`)
        .then(()=>{
            history.push('/');
        })
    }

    return (
        <div className='content expertMap'>
            { 
                type === 'accident' ?
                    <div className='mt20 b-bl-sharp file-info'>
                        {/* همکار محترم، جناب
                        {` ${user?.full_name || ''} `}
                        پرونده
                        {data.insurance_type === 'third' ? ' ثالث ' : ' بدنه '}
                        به شماره پرونده
                        {` ${data?.id || ''} `}
                        جهت رسیدگی با مشخصات زیر به شما ارجاع شد. */}
                        <p>{t('Expert map accident title',{name:user?.full_name || '',insuranceType:data.insurance_type === 'third' ? t('Third') : t('Body'),fileNum:data?.id || ''})}</p>
                    </div> :
                    <div className='mt20 b-bl-sharp file-info'>
                        {/* همکار محترم، جناب
                        {` ${user?.full_name || ''} `}
                        پرونده صدور
                        به شماره پرونده
                        {` ${data?.id || ''} ${data?.type || ''} `}
                        با مشخصات زیر به شما ارجاع شد. */}
                        <p>{t('Expert map issued title',{name:user?.full_name || '',fileNum:data?.id || '',fileType:data?.type || ''})}</p>
                    </div>
            }
            <div className='user-box'>
                <div className={`d-flex align-items-center space-between ${getDirection(i18n.language)=== 'leftToRight' ? 'flex-row-reverse':''}`}>
                    <a href={`tel:${culprit.mobile}`} className='btn btn-orange btn-block btn-circle btn-sm' style={{ width: 'auto' }}><i className='fas fa-phone'/></a>
                    <div className={`d-flex align-items-center ${getDirection(i18n.language)=== 'leftToRight' ? 'flex-row-reverse':''}`}>
                    <p className='px10'>
                        {type === 'accident' ?  t('Culprit') :t('Applicant')} : {culprit.full_name}
                    </p>
                    <img
                        src={
                            profilePic
                                ? `${url}/files?uid=${profilePic}&width=72&height=72`
                                : defaultProfile
                        }
                        className={`profile-picture ${!profilePic ? 'defaultPic': ''}`} alt='profile-pic'
                    />
                    </div>
                </div>
            </div>
            {
                losses.map((l, i) => (
                    <div className='user-box' key={i}>
                        <div className={`d-flex align-items-center space-between ${getDirection(i18n.language)=== 'leftToRight' ? 'flex-row-reverse':''}`}>                           
                            <a href={`tel:${l.user.mobile}`} className='btn btn-orange btn-block  btn-circle btn-sm' style={{ width: 'auto' }}><i className='fas fa-phone'/></a>
                            <div className={`d-flex align-items-center ${getDirection(i18n.language)=== 'leftToRight' ? 'flex-row-reverse':''}`}>
                            <p className='px10'>
                                {t('Losses')} {t(latinAlphabet[i])} : {l.user.full_name}
                            </p>
                            <img
                                src={
                                    l.user.avatar
                                        ? `${url}/files?uid=${l.user.avatar.uid}&width=72&height=72`
                                        : defaultProfile
                                }
                                className={`profile-picture ${!l.user.avatar ? 'defaultPic': ''}`} alt='profile-pic'
                            />
                            </div>
                        </div>
                    </div>
                ))
            }
            {
                !!descriptions?.length &&
                <div className={`user-box-des ${getDirection(i18n.language) === 'rightToLeft'? 'text-right':'text-left'}`}>
                    <strong>: {t('File description')}</strong>
                    <ul className='mt5 mb5' dir={getDirection(i18n.language) === 'rightToLeft'? 'rtl':'ltr'}>
                        {
                            descriptions.map((desc, index) => (
                                <li key={index}>
                                    <p>
                                        {desc.description}
                                    </p>
                                </li>
                            ))
                        }

                    </ul>
                </div>
            }
            <div className='mt10'>
                <div className={`input-parent mt20`} style={{position:'relative'}}>
                    <input
                        className='pl45 pt5 pb5 text-right'
                        type='text'
                        value={newDescription}
                        placeholder={t('Description')}
                        onChange={e => setNewDescription(e.target.value)}
                    />

                    <button className='btn btn-green add-des-btn btn-circle btn-sm' disabled={descriptionLoading} onClick={submitNewDescription} >
                        <i className="fas fa-plus"></i>
                    </button>
                </div>

            </div>
            {
                (data.lat && data.lng) &&
                <a href={`http://maps.google.com/maps?daddr=${data.lat} ,${data.lng}`}>
                    <div className='maps mt20'>
                        <Maps
                            loc={[
                                data.lat,
                                data.lng,
                            ]}
                        />
                    </div>
                </a>
            }
            <div className='d-flex'>
            <button className='btn btn-white-purple btn-circle btn-block mt20 ml5 mr5' disabled={loader} onClick={arrived}>
                {
                    loader
                        ? <i className='fas fa-spinner fa-spin' />
                        : t('I reached my destination')
                }
            </button>
            {!!data.online_progress && 
            <button className='btn btn-orange btn-circle btn-block mt20 ml5 mr5' onClick={onlineExamine}>
                کارشناسی با سیستم
            </button>
            }
            </div>
        </div>
    )

}
